import { filterConditionConfigModel } from '@/model'
import {
	allBatteries,
	allCarColors,
	allCarTypes,
	allBrands
} from '@/views1/IndexPage/filterOptions'

const STORAGE_KEY = 'secondHandFilterConditionConfig'
const FILTER_CONDITION_KEY = 'commodity.toc.filter-condition'

function safeParse(value) {
	try {
		const data = JSON.parse(value)
		return data && typeof data === 'object' && !Array.isArray(data) ? data : {}
	} catch (e) {
		return {}
	}
}

function formatOptions(options) {
	return Array.isArray(options) ? options.map(item => ({ value: item.code, label: item.name })) : []
}

function formatFilter(condition = {}) {
	const source = condition && typeof condition === 'object' ? condition : {}

	// 车辆车系枚举
	const carTypes = formatOptions(source.vehicle_series)
	// 车辆电池枚举
	const batteries = formatOptions(source.battery)
	// 车辆品牌枚举
	const brands = formatOptions(source.brand)
	// 车辆颜色枚举
	const colors = Array.isArray(source.vehicle_colors)
		? source.vehicle_colors
				.filter(item => item && item.name)
				.map(item => ({
					value: item.name,
					hex: item.icon || '',
					includes: Array.isArray(item.includes) ? item.includes : []
				}))
		: []

	return {
		carTypes: carTypes.length ? carTypes : allCarTypes,
		batteries: batteries.length ? batteries : allBatteries,
		colors: colors.length ? colors : allCarColors,
		brands: brands.length ? brands : allBrands
	}
}

function getLocalConfig() {
	try {
		const config = localStorage.getItem(STORAGE_KEY)
		return config ? safeParse(config) : {}
	} catch (e) {
		return {}
	}
}

function setLocalConfig(config) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
	} catch (e) {
		// 忽略本地存储不可用的情况
	}
}

const localConfig = getLocalConfig()
const state = {
	data: localConfig,
	filterCondition: formatFilter(localConfig)
}

const mutations = {
	setData(state, data) {
		state.data = data || {}
		state.filterCondition = formatFilter(state.data)
		setLocalConfig(state.data)
	}
}

const actions = {
	async fetchFilterConditionConfig({ commit, state }) {
		try {
			const { data } = await filterConditionConfigModel.get({ keys: FILTER_CONDITION_KEY })
			const resConfig = data && data.data ? data.data[FILTER_CONDITION_KEY] : undefined
			if (!resConfig) {
				return state.filterCondition
			}
			commit('setData', resConfig)
		} catch (e) {
			// 接口失败时继续使用本地缓存
		}

		return state.filterCondition
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
